import React from 'react';
import CatalogDomLink from './CatalogDoomLink';
import Copyright from './Copyright';


const Footer = () => {
    return (
        <>
            <Copyright />
            <CatalogDomLink />
        </>
    )
}
export default Footer;